import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/** Legacy `/facilities/:id` URLs open the facility side sheet on Overview. */
const facilityDetailSearchSchema = z.object({
  externalCustomerId: z.string().trim().min(1).optional(),
  tab: z.enum(["overview", "maturity", "value", "achievements"]).optional(),
});

export const Route = createFileRoute("/_app/facilities/$facilityId")({
  validateSearch: (search) => facilityDetailSearchSchema.parse(search),
  beforeLoad: ({ params, search }) => {
    const facilityId = Number(params.facilityId);
    if (!Number.isFinite(facilityId) || facilityId <= 0) {
      throw redirect({ to: "/" });
    }
    if (!search.externalCustomerId) {
      throw redirect({ to: "/" });
    }
    throw redirect({
      to: "/",
      search: {
        externalCustomerId: search.externalCustomerId,
        facilityId,
        tab: search.tab,
      },
    });
  },
  component: () => null,
});
